import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const LineItems = {
  id: 'lineItems',
  displayName: <FormattedMessage {...messages.lineItems} />,
  type: OptionFormTypes.TYPE_NUMBER_COMPARISON,
  filterValue: 'LineItemCount',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_NUMBER_COMPARISON, criteriaInformations);
  },
};
